<template>
<div class="chapter">
<div class="inner_page">
<div class="section level2" id="a-midsummer-nights-dream">
<h2>A Midsummer Night’s Dream</h2>
<p>Tucked away in a tranquil street</p>
<p>That we stumbled upon simply by chance</p>
<p>Delicate diamonds fell from the Heavens</p>
<p>And across the black asphalt, the city lights danced</p>
<br/>
<p>Your hand gently rested at the small of my back</p>
<p>As soft laughter resonated from the café alongside</p>
<p>Where cigarettes dangled between Parisian fingertips</p>
<p>And glasses were raised to the beauty of life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?70d3fc12